export const footerlink = [
    {
        name:"Facebook",
        link:"https://www.facebook.com/chanchal.panpaliya"
    },
    {
        name:"Twitter",
        link:"https://twitter.com/CPanpaliya"
    },
    {
        name:"Linkedin",
        link:"https://www.linkedin.com/in/chanchal-panpaliya-0b0436112"
    },
    {
        name:"Github",
        link:"https://github.com/chanchal-panpaliya"
    }
]